import Vue from 'vue';
import { Auth } from '@aws-amplify/auth';
import { Storage } from '@aws-amplify/storage';
import { usersAPI } from '../shared/services/users.service'

Vue.mixin({
  methods: {
    roundToDecimals (value, decimals = 2) {
      return Number(Math.round(`${value}e${decimals}`) + 'e-' + decimals);
    },
    getImageUrl (name = '') {
      return Storage.get(name).then((response) => {
        return response;
      }).catch((error) => {
        return error;
      });
    },
    getCurrentUser () {
      return Auth.currentAuthenticatedUser({
        bypassCache: true 
    }).then((user) => {
        return user;
      }).catch(() => {
        this.$router.push({ name: 'SignIn' });
      });
    },
    async getUsersFromGroup (groupName = '', userList = [], paginationToken = '') {

      const payload = {}

      if(paginationToken) {
        payload.headers = {
          'Pagination-Token': paginationToken
        }
      }
  
      const [ cognitoError, users, headers ] = await usersAPI.getUsersByGroup(groupName, payload)

      if(cognitoError) {
        this.getCurrentUser().then((user) => {
          if (!userList.find(userFromList => userFromList.sub === user.attributes.sub)) {
            userList.push({
              'firstName': user.attributes.name,
              'surName': user.attributes.family_name,
              'phone': user.attributes.phone_number,
              'sub': user.attributes.sub
            });
          }
        });
      } else {
        users.map((user) => {
          if (!userList.find(userFromList => userFromList.sub === user.username)) {
            userList.push({
              'firstName': user.name,
              'surName': user.lastname,
              'phone': user.phoneNumber,
              'sub': user.username
            });
          }
        });
        if (headers['pagination-token']) {
          this.getUsersFromGroup(groupName, userList, headers['pagination-token']);
        }
      }
    }
  }
})
;
